import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  headerTitleText: () => i18n.t(i18nKeys.deliveryIssue_header),
  merchantTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_merchant_title),
  requiredStepsTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_requiredSteps_title),
  requiredStepsDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_requiredSteps_description),
  additionalInfoTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_additionalInfo_title),
  additionalInfoDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_additionalInfo_description),
  additionalDetailsSubmittedText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_additionalDetails_hasSubmitted),
  additionalDetailsNotSubmittedText: () =>
    i18n.t(
      i18nKeys.deliveryIssueDetail_section_additionalDetails_hasNotSubmitted
    ),
  dxEnteredGeoFenceTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxEnteredGeoFence_title),
  dxEnteredGeoFenceDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxEnteredGeoFence_description),
  dxContactedCxTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxContactedCx_title),
  dxContactedCxDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxContactedCx_description),
  dxWaitedTitleText: () => i18n.t(i18nKeys.deliveryIssueStep_DxWaited_title),
  dxWaitedDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxWaited_description),
  dxLeftPhotoTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxLeftPhoto_title),
  dxLeftPhotoDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxLeftPhoto_description),
  missingSteps: ({ missed, total }) =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_requiredSteps_missed_count, {
      missed,
      total,
    }),
  neverDeliveredTitle: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_neverDelivered_title),
  extremelyLateTitle: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_extremelyLate_title),
  customerReported: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_customerReported),
  neverDeliveredDescription: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_neverDelivered_description),
  extremelyLateDescription: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_extremelyLate_description),
  neverDeliveredAdditionalInfo1: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_neverDelivered_additionalInfo1),
  extremelyLateAdditionalInfo1: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_extremelyLate_additionalInfo1),
  policyAdditionalInfo: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_policy_additionalInfo),
  extremelyLateAdditionalInfo2: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_extremelyLate_additionalInfo2),
  submittedDetails: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_submittedDetails),
  lateCardStoreTitle: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_extremelyLateCard_lateStoreTitle),
  lateCardStoreScheduledDescription: () =>
    i18n.t(
      i18nKeys.deliveryIssueDetail_extremelyLateCard_lateStoreScheduledDescription
    ),
  lateCardStoreActualDescription: () =>
    i18n.t(
      i18nKeys.deliveryIssueDetail_extremelyLateCard_lateStoreActualDescription
    ),
  lateCardCustomerTitle: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_extremelyLateCard_lateCustomerTitle),
  lateCardCustomerScheduledDescription: () =>
    i18n.t(
      i18nKeys.deliveryIssueDetail_extremelyLateCard_lateCustomerScheduledDescription
    ),
  lateCardCustomerActualDescription: () =>
    i18n.t(
      i18nKeys.deliveryIssueDetail_extremelyLateCard_lateCustomerActualDescription
    ),
  submissionToastText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_submissionToast),
}
